<script lang="ts">
	import type { ComponentProps } from 'svelte';
	import Badge from '$lib/components/atoms/badge/Badge.svelte';
	import Carousel from '$lib/components/molecules/carousel/Carousel.svelte';
	import PoiImage from '../../image/PoiImage.svelte';
	import PriceTag from '../poiCardPriceTag/PoiCardPriceTag.svelte';

	interface Props {
		image?: Exclude<ComponentProps<typeof PoiImage>, 'class'>;
		carousel?: ComponentProps<typeof Carousel>;
		badge?: ComponentProps<typeof Badge>;
		priceTag?: ComponentProps<typeof PriceTag>;
		layout?: 'vertical' | 'horizontal';
		class?: string;
	}

	const { image, carousel, badge, priceTag, layout = 'vertical', class: classes }: Props = $props();

	const wrapperTag = image ? 'figure' : 'div';
	const imagesClasses = layout === 'horizontal' ? 'rd-bl-2 rd-tl-2 h-132px w-full' : 'rd-tr-2 rd-tl-2 h-full w-full';
</script>

<svelte:element this={wrapperTag} data-testid="poi-card-hero" class={['poi-card-hero group grid w-full h-full max-h-132px p-0 m-0 overflow-hidden', classes, layout]}>
	{#if image}
		<PoiImage
			{...image}
			class={['image w-full grid-area-[1/-1]', imagesClasses]}
		/>
	{:else if carousel}
		<Carousel
			{...carousel}
			containerClasses="carousel h-full max-h-132px w-full grid-area-[1/-1] overflow-hidden"
			carouselClasses={imagesClasses}
			controlsClasses="poi-card-hero-controls"
		/>
	{/if}
	{#if badge}
		<div class="opacity-container relative self-start justify-self-end grid-area-[1/-1] p-2 group-has-hover:opacity-0 group-has-[.no-hover]:opacity-100">
			<Badge {...badge} />
		</div>
	{/if}
	{#if priceTag}
		<div class="opacity-container relative self-end grid-area-[1/-1] p-2 group-has-hover:opacity-0 group-has-[.no-hover]:opacity-100">
			<PriceTag {...priceTag} />
		</div>
	{/if}
</svelte:element>

<style>

	@media (hover: hover) and (pointer: fine) {
		.poi-card-hero:hover :global(.right-arrow-container),
		.poi-card-hero:hover :global(.left-arrow-container) {
			visibility: visible;
		}
	}

	@media (hover:none) and (pointer: coarse) {
		.poi-card-hero:active :global(.opacity-container),
		.poi-card-hero:global(:has(:active)) :global(.opacity-container),
		.poi-card-hero:global(:has(:focus)) :global(.opacity-container),
		.poi-card-hero:has(:active):global(.opacity-container),
		.poi-card-hero:focus-within :global(.opacity-container) {
			opacity: 0;
		}

		.poi-card-hero.no-hover :global(.opacity-container) {
			opacity: 1;
		}
	}

	.poi-card-hero :global(.right-arrow-container),
	.poi-card-hero :global(.left-arrow-container) {
			visibility: hidden;
	}

	.poi-card-hero.vertical :global(.left-arrow-container) {
		border-top-left-radius: 12px;
	}

	.poi-card-hero.vertical :global(.left-arrow-container) {
		border-top-left-radius: 12px;
	}

	.poi-card-hero.horizontal :global(.left-arrow-container) {
		border-top-left-radius: 12px;
		border-bottom-left-radius: 12px;
	}
</style>
